<script setup lang="ts">
import { ref } from 'vue';
import { useParticipantStore } from '@/Stores/ParticipantStore';
import { useCopy, renderCopy } from '@/copy';

const pStore = useParticipantStore()
const copy = useCopy()

// The questionnaire screen and the thank-you screen share this route; once submitted
// (now, or on a reload after a previous submit) we show the confirmation instead.
const completed = ref(pStore.state.questionnaireCompleted)
const submitting = ref(false)
const errorMessage = ref<string | null>(null)

async function submit() {
    if (submitting.value) {
        return
    }

    submitting.value = true
    errorMessage.value = null

    const res = await pStore.completeQuestionnaire()

    submitting.value = false

    if (!res.ok) {
        errorMessage.value = res.message
        return
    }

    completed.value = true
}
</script>

<template>
    <div v-if="completed" data-testid="questionnaire-completed" class="w-full text-center h-full col justify-center items-center text-xl px-6">
        <div class="copy-html max-w-150" v-html="renderCopy(copy('questionnaire_completed'))"></div>
    </div>

    <template v-else>
        <div class="w-full text-center h-full col justify-center text-xl">
            <span>Questionario</span>
        </div>

        <p v-if="errorMessage" class="absolute bottom-35 left-[50%] translate-x-[-50%] text-red-600 text-sm">
            {{ errorMessage }}
        </p>

        <button :disabled="submitting" @click="submit" data-testid="questionnaire-submit"
            class="btn-primary absolute bottom-20 left-[50%] translate-x-[-50%] text-md! p-4!">
            {{ submitting ? 'Invio in corso…' : 'Completa questionario' }}
        </button>
    </template>
</template>

<style scoped>
</style>
